import { CallableQueue, Device, QUEUE } from "callable-data-objects";
import { useDevice } from "Hooks/Endpoints";
import { APIDeviceProps } from "Providers/types";
import React, { Fragment } from "react";
import { Button, Container, Label, Table } from "semantic-ui-react";

const ClientQueues = () => {
  const { device, devices, update }: APIDeviceProps = useDevice();
  if (!device || !devices) return <Fragment />;
  const filtered = devices.filter((d) => d.type === QUEUE);
  const { client } = device;
  const { queues } = client;

  const queueSelected = (id: string): boolean => {
    return queues && queues.find((q) => q.id === id) !== undefined;
  };

  async function disconnect(id: string) {
    if (device) {
      const newQueues = queues.filter((q) => q.id !== id);
      const payload = {
        ...device,
        client: {
          ...device.client,
          queues: newQueues,
        },
      };
      update(payload);
    }
  }

  async function connect(newDevice: Device) {
    if (device) {
      const q = new CallableQueue({
        id: newDevice.id,
        name: newDevice.queue.queueName,
        position: 10,
        color: "blue",
        ring: true,
      });
      let qs = queues;
      if (!qs) {
        qs = [];
      }
      qs.push(q);
      const payload = {
        ...device,
        client: {
          ...device.client,
          queues: qs,
        },
      };
      update(payload);
    }
  }

  return (
    <Container fluid>
      <Table celled padded stackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1} singleLine></Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Name
            </Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Extension
            </Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Queue Name
            </Table.HeaderCell>
            <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {filtered.map((d: Device) => (
            <Table.Row key={`tr-${d.id}`}>
              <Table.Cell singleLine>
                {queueSelected(d.id) ? (
                  <Label color='blue' ribbon>
                    Selected
                  </Label>
                ) : (
                  ""
                )}
              </Table.Cell>

              <Table.Cell singleLine>{d.name}</Table.Cell>

              <Table.Cell singleLine>{d.extension}</Table.Cell>

              <Table.Cell singleLine>{d.queue && d.queue.queueName}</Table.Cell>

              <Table.Cell singleLine>
                {queueSelected(d.id) ? (
                  <Button
                    size='tiny'
                    color='red'
                    onClick={() => disconnect(d.id)}
                  >
                    Unselect
                  </Button>
                ) : (
                  <Button size='tiny' color='blue' onClick={() => connect(d)}>
                    Select
                  </Button>
                )}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Container>
  );
};

export default ClientQueues;
